import { ContentWrapper } from '@/components/_common';
import { Descriptions, Tooltip, Typography } from 'antd';
import moment from 'moment';
import { currencyFormatter } from '@/utils/number';
import { DashboardData } from '@/core/domain/workorder/Dashboard/Dashboard.types';
import { useWindowSize } from '@/hooks';

interface Props {
  dashboardData?: DashboardData;
}

function ForecastCalcReceivableAndPayable({ dashboardData }: Props) {
  const valueTotal =
    (dashboardData?.receivableForecastValue ?? 0) -
    (dashboardData?.payableForecastValue ?? 0);

  const { isMobile } = useWindowSize();

  return (
    <ContentWrapper style={{ minHeight: '360px' }}>
      <Descriptions
        title="PREVISÃO"
        layout={isMobile ? 'vertical' : 'horizontal'}
        bordered
      >
        <Descriptions.Item
          span={3}
          label={`Receitas - ${moment().format('MMM').toUpperCase()}`}
        >
          <Tooltip
            overlayStyle={{ maxWidth: '500px' }}
            title="Total dos lançamentos do contas a receber com data de pagamento igual ao mês atual + total dos lançamentos do contas a receber com data de vencimento igual ao mês atual."
          >
            <Typography.Text style={{ color: 'rgb(160, 206, 51)' }}>
              {`${currencyFormatter(dashboardData?.receivableForecastValue)}`}
            </Typography.Text>
          </Tooltip>
        </Descriptions.Item>

        <Descriptions.Item
          span={3}
          label={`Despesas - ${moment().format('MMM').toUpperCase()} `}
        >
          <Tooltip
            overlayStyle={{ maxWidth: '500px' }}
            title="Total dos lançamentos do contas a pagar com data de pagamento igual ao mes atual + total dos lançamentos do contas a pagar com data de vencimento igual ao mes atual."
          >
            <Typography.Text style={{ color: 'rgb(207, 74, 29)' }}>
              {`${currencyFormatter(dashboardData?.payableForecastValue)}`}
            </Typography.Text>
          </Tooltip>
        </Descriptions.Item>

        <Descriptions.Item label="Total" span={3}>
          <Tooltip title="Receita - Despesas">
            <Typography.Text
              style={{
                color:
                  valueTotal < 0 ? 'rgb(207, 74, 29)' : 'rgb(160, 206, 51)',
              }}
            >
              {`${currencyFormatter(valueTotal)}`}
            </Typography.Text>
          </Tooltip>
        </Descriptions.Item>
      </Descriptions>
    </ContentWrapper>
  );
}

export default ForecastCalcReceivableAndPayable;
